/**
 * Maps an API violation path to the corresponding form field path of the classroom template edit form.
 *
 * ERP import violations are reported by the API on a virtual 'periods' property, under either
 * 'actions' or 'trainingActions', and must be mapped to the real matching form field, which is 'erpFile'.
 */
export const mapViolationPathToFormPath = (fieldPath: string) =>
    fieldPath.replace(/^(?:trainingActions|actions)\.(\d+)\.periods$/, "trainingActions.$1.erpFile");
